import { createFileRoute } from '@tanstack/react-router';

import { ComingSoonPage } from '@/components/coming-soon-page';

export const Route = createFileRoute('/providers')({
  component: () => (
    <ComingSoonPage
      title="Providers"
      description="Provider management will appear here once the provider directory is wired up."
      testId="providers-page"
    />
  ),
});
